var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.options.popupVisible),callback:function ($$v) {_vm.$set(_vm.options, "popupVisible", $$v)},expression:"options.popupVisible"}},[_c('mt-picker',{attrs:{"slots":_vm.slots},on:{"change":_vm.onValuesChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }